var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataMaintenance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 140,
    viewBox: "0 0 180 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M89.9248 15.5253C89.9248 15.5253 84.182 13.9643 82.9551 8.65697C82.9551 8.65697 91.8304 6.86705 92.081 15.9935L89.9248 15.5253Z",
    fill: "#0D9F3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M90.6244 14.9582C90.6244 14.9582 86.6201 8.65706 90.1441 2.76178C90.1441 2.76178 96.8893 7.03365 93.8926 14.9738L90.6244 14.9582Z",
    fill: "#0D9F3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6699 14.9633C91.6699 14.9633 93.7582 8.30838 100.164 7.04919C100.164 7.04919 101.36 11.3679 96.024 14.9842L91.6699 14.9633Z",
    fill: "#0D9F3F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5078 14.8124L88.6668 22.7318L95.9759 22.763L97.0566 14.8541L87.5078 14.8124Z",
    fill: "#24285B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M89.7735 134.903C137.816 134.903 176.762 130.398 176.762 124.84C176.762 119.283 137.816 114.777 89.7735 114.777C41.7312 114.777 2.78516 119.283 2.78516 124.84C2.78516 130.398 41.7312 134.903 89.7735 134.903Z",
    fill: "#E6E6E6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M113.525 28.6011H53.6895V127.244H113.525V28.6011Z",
    fill: "#24285B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M103.62 33.4766H63.4673C60.7886 33.4766 58.6172 35.6407 58.6172 38.3104V44.5075C58.6172 47.1771 60.7886 49.3413 63.4673 49.3413H103.62C106.299 49.3413 108.47 47.1771 108.47 44.5075V38.3104C108.47 35.6407 106.299 33.4766 103.62 33.4766Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1864 22.9348H67.7285V28.6011H98.1864V22.9348Z",
    fill: "#0D9F3F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3793 45.6781C101.732 45.6781 103.639 43.7772 103.639 41.4323C103.639 39.0873 101.732 37.1864 99.3793 37.1864C97.0265 37.1864 95.1191 39.0873 95.1191 41.4323C95.1191 43.7772 97.0265 45.6781 99.3793 45.6781Z",
    fill: "#0D9F3F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8169 39.4135H63.7207V43.446H88.8169V39.4135Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M103.62 57.5936H63.4673C60.7886 57.5936 58.6172 59.7578 58.6172 62.4274V68.6245C58.6172 71.2942 60.7886 73.4583 63.4673 73.4583H103.62C106.299 73.4583 108.47 71.2942 108.47 68.6245V62.4274C108.47 59.7578 106.299 57.5936 103.62 57.5936Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3793 69.79C101.732 69.79 103.639 67.889 103.639 65.5441C103.639 63.1992 101.732 61.2983 99.3793 61.2983C97.0265 61.2983 95.1191 63.1992 95.1191 65.5441C95.1191 67.889 97.0265 69.79 99.3793 69.79Z",
    fill: "#0D9F3F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8169 63.5253H63.7207V67.5578H88.8169V63.5253Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M103.62 81.7054H63.4673C60.7886 81.7054 58.6172 83.8696 58.6172 86.5393V92.7363C58.6172 95.406 60.7886 97.5702 63.4673 97.5702H103.62C106.299 97.5702 108.47 95.406 108.47 92.7363V86.5393C108.47 83.8696 106.299 81.7054 103.62 81.7054Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3793 93.9019C101.732 93.9019 103.639 92.0009 103.639 89.656C103.639 87.3111 101.732 85.4102 99.3793 85.4102C97.0265 85.4102 95.1191 87.3111 95.1191 89.656C95.1191 92.0009 97.0265 93.9019 99.3793 93.9019Z",
    fill: "#0D9F3F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8169 87.6371H63.7207V91.6697H88.8169V87.6371Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M103.62 105.817H63.4673C60.7886 105.817 58.6172 107.981 58.6172 110.651V116.848C58.6172 119.518 60.7886 121.682 63.4673 121.682H103.62C106.299 121.682 108.47 119.518 108.47 116.848V110.651C108.47 107.981 106.299 105.817 103.62 105.817Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3793 118.014C101.732 118.014 103.639 116.113 103.639 113.768C103.639 111.423 101.732 109.522 99.3793 109.522C97.0265 109.522 95.1191 111.423 95.1191 113.768C95.1191 116.113 97.0265 118.014 99.3793 118.014Z",
    fill: "#0D9F3F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8169 111.754H63.7207V115.787H88.8169V111.754Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M130.141 101.675H125.609V127.239H130.141V101.675Z",
    fill: "#0D9F3F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M154.627 101.675H150.096V127.239H154.627V101.675Z",
    fill: "#0D9F3F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M130.141 101.675H125.609V127.239H130.141V101.675Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M154.627 101.675H150.096V127.239H154.627V101.675Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M160.009 89.6352H120.242V103.616H160.009V89.6352Z",
    fill: "#0D9F3F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M122.262 89.6352L127.007 103.616H133.586L128.182 89.6352H122.262Z",
    fill: "#24285B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M134.432 89.6352L139.183 103.616H145.755L140.352 89.6352H134.432Z",
    fill: "#24285B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M146.566 89.6352L151.317 103.616H157.89L152.487 89.6352H146.566Z",
    fill: "#24285B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M160.009 108.913H120.242V115.469H160.009V108.913Z",
    fill: "#0D9F3F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M160.009 108.913H120.242V115.469H160.009V108.913Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1493 57.9058H8.68945V95.7178H42.1493V57.9058Z",
    fill: "#E6E6E6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4244 62.5627L13.6934 80.4671H25.4244H37.1502L25.4244 62.5627Z",
    fill: "#FFD200"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1576 69.2228H24.4922V74.603H26.1576V69.2228Z",
    fill: "#24285B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1576 75.6541H24.4922V77.3139H26.1576V75.6541Z",
    fill: "#24285B"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M37.145 84.2707H13.6934V90.6499H37.145V84.2707Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataMaintenance);
export default __webpack_public_path__ + "static/media/data_maintenance.0673db0d5e8bbdf23f77dac809f130f3.svg";
export { ForwardRef as ReactComponent };